<template>
  <div class="container pdf-print-vital-sign">
    <ErrorsMessages :errors="errors" />
    <div class="row">
      <div
        class="pl-0 pt-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
      >
        <v-btn @click="handlePrint" class="btn-print"
          ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
        >
      </div>
      <div v-show="errors.length == 0" class="pl-0 pt-0 col-md-12">
        <b-overlay :show="loading" opacity="0.99">
          <table class="table table-sm bg-white">
            <div class="row p-1">
              <div
                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex align-items-center pt-0 pb-0"
              >
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url" class="ml-1">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div
                class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 d-flex align-items-center pt-0 pb-0"
              >
                <img
                  v-if="care_vital_signs.resident_photo_url"
                  class="resident_photo_url"
                  :src="care_vital_signs.resident_photo_url"
                />
                <img
                  v-if="!care_vital_signs.resident_photo_url"
                  class="resident_photo_url"
                  :src="require('../../../../assets/user.png')"
                />
                <div class="ml-1">
                  <h6 class="mb-0">
                    {{ care_vital_signs.resident_name }}
                  </h6>
                  <h6 class="mb-0 worksansr upper-text">
                    Data de nascimento:
                    {{
                      formatDate(care_vital_signs.resident_date_of_birth, false)
                    }}
                    -
                    {{ getAge(care_vital_signs.resident_date_of_birth) }}
                    anos
                  </h6>
                  <h6 class="mb-0 worksansr upper-text">
                    Data de admissão:
                    {{
                      formatDate(
                        care_vital_signs.resident_date_of_reception,
                        false
                      )
                    }}
                  </h6>
                  <p class="m-0" v-if="care_vital_signs.resident_bed_id">
                    <span class="text-muted">Leito: </span>
                    <span class="text-muted">Nº: </span>
                    {{ care_vital_signs.resident_bed_number }}
                    ,
                    <span class="text-muted">Andar: </span>
                    {{ care_vital_signs.resident_bed_walk }}
                    ,
                    <span class="text-muted">ALA/Setor: </span>
                    {{ care_vital_signs.resident_bed_ward_or_sector }}
                    ,
                    <span class="text-muted">Quarto: </span>
                    {{ care_vital_signs.resident_bed_bedroom }}
                  </p>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 d-flex align-items-center justify-content-end pt-0 pb-0"
              >
                <img class="logo" :src="logo" />
              </div>
            </div>
            <tbody>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center pt-0 pb-0"
              >
                <hr class="m-1" />
                <h6 class="upper-text mb-1">
                  Cuidados - Sinais Vitais -
                  {{ formatDate(care_vital_signs.created_at, false) }}
                </h6>
              </div>
              <tr v-for="(item, key) in care_has_vital_signs" :key="key">
                <td>
                  <div class="row">
                    <div
                      class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-0 pb-0"
                    >
                      <h6 class="upper-text mb-0 worksansr">
                        {{ item.type }}

                        {{ item.title }} - {{ item.description }}
                        {{
                          item.type == "DOR"
                            ? `(${handleDescriptionAche(item.description)})`
                            : item.abbreviation
                        }}
                      </h6>
                    </div>
                    <div
                      class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-0 pb-0"
                    >
                      <h6 class="upper-text mb-0 worksansr">
                        {{ item.status == 1 ? "EM ABERTO" : "FINALIZADO" }}
                      </h6>
                    </div>
                    <div
                      class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-0 pb-0"
                    >
                      <h6 class="upper-text mb-0 worksansr text-fourteen">
                        {{
                          professionalClassCouncilValue({
                            id: item.user_professional_class_council_id,
                            name: item.user_name,
                            profile: item.user_profile_name,
                            cpf: item.user_cpf,
                            office: item.user_office,
                            value: item.user_professional_class_council_value,
                          })
                        }}
                        <small>
                          - {{ formatDate(care_vital_signs.created_at) }}
                        </small>
                      </h6>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-overlay>
      </div>
      <div
        class="pl-0 pt-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
      >
        <v-btn @click="handlePrint" class="btn-print"
          ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import { getAge } from "../../../../lib/getAgeByDate";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import routes from "../../../../routes";

import { userData } from "../../../../lib/functions";

export default {
  name: "PrintVitalSign",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      errors: [],
      care_vital_signs: {},
      care_has_vital_signs: [],
      rest_home_id: "",
      client: {},
      user: {},
      rest_home_name: null,
      rest_home_logo_url: null,
      logo: null,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    formatDate,
    professionalClassCouncilValue,
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    async retrieve() {
      const { id } = routes.history.current.params;

      const { user, rest_home_id, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.id = id;
      this.user = user;
      this.rest_home_id = rest_home_id;

      await this.getClient();
      await this.get();
    },
    async getClient() {
      try {
        this.loading = true;

        const { rest_home_id: id } = this;

        var params = { id };

        const response = await api.get("/rest-home/path", {
          params,
        });

        const { error, errors, client } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.client = client;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/vital-sign/print", {
          params,
        });

        const { error, errors, care_vital_signs, care_has_vital_signs } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.care_vital_signs = care_vital_signs;
          this.care_has_vital_signs = care_has_vital_signs;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePrint: () => window.print(),
  },
};
</script>

<style>
.pdf-print-vital-sign .header,
.pdf-print-vital-sign .header-space {
  height: 150px;
}
.pdf-print-vital-sign .header {
  position: fixed;
  top: 0;
}
.pdf-print-vital-sign .medicine {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.pdf-print-vital-sign .name {
  font-weight: bold;
}
.pdf-print-vital-sign .active-ingredient {
  font-size: 12px;
}
.pdf-print-vital-sign .via {
  font-weight: bold;
  font-size: 12px;
}
.pdf-print-vital-sign .user {
  transform: rotate(290deg) !important;
  font-size: 8px;
  width: 20px;
}
.pdf-print-vital-sign .checked-icon {
  width: 15px;
}
.pdf-print-vital-sign .logo {
  height: 50px;
  object-fit: contain;
}
.pdf-print-vital-sign .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.pdf-print-vital-sign .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  .pdf-print-vital-sign button {
    display: none;
  }
  .pdf-print-vital-sign li {
    list-style-type: none;
  }
}
</style>